import UserDispatcherUpdateRequest from "../../../../api/raily/user/dispatcher/update/user-dispatcher-update.request";
import UserDispatcherUpdateParams from "./user-dispatcher-update-params";

const create = (
  params: UserDispatcherUpdateParams,
): UserDispatcherUpdateRequest => {
  return {
    dispatcherId: params.dispatcherUuid,
    dispatchId: params.dispatchUuid,
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    mobilePrimary: params.phoneNumber.number,
    mobilePrimaryPrefix: params.phoneNumber.dialingCode,
    mobileSecondary: params.alternativePhoneNumber.number || null,
    mobileSecondaryPrefix: params.alternativePhoneNumber.dialingCode || null,
  };
};

const userDispatcherUpdateParamsFactory = {
  create,
};

export default userDispatcherUpdateParamsFactory;
